<template>
  <div class="flexContainer">
    <div class="tableItemContainer">
      <title-block
        style="display: inline-block"
        title="Gebruikers"
        class="accountstitle"
        :callback="GetOrRefreshData"
      ></title-block>
      <b-button style="float: right" v-if="adminClaim" @click="showAdminButton = !showAdminButton">Admin</b-button>
      <div class="tableSettings">
        <div class="field">
          <div class="label is-small">Zoeken:</div>
          <input class="input is-small" type="text" v-model="searchTerm" placeholder="Typ hier uw zoekopdracht..." />

          <b-select v-model="perPage" class="is-size-7 float-right">
            <option value="5">5 per pagina</option>
            <option value="10">10 per pagina</option>
            <option value="15">15 per pagina</option>
            <option value="20">20 per pagina</option>
            <option value="0">alle</option>
          </b-select>
          <div class="label is-small float-right">Aantal items per pagina:</div>
        </div>
      </div>
      <br />
      <b-table
        class="accounts-table"
        :data="filteredAccounts"
        default-sort-direction="asc"
        default-sort="name"
        :paginated="perPage > 0"
        :per-page="perPage"
        @click="row => rowClicked(row)"
        hoverable
      >
        <template>
          <b-table-column cell-class="pointer" field="email" label="Email" sortable v-slot="props">{{
            props.row.email
          }}</b-table-column>
          <b-table-column cell-class="pointer" field="firstName" label="Voornaam" sortable v-slot="props">{{
            props.row.firstName | capitalize
          }}</b-table-column>
          <b-table-column cell-class="pointer" field="lastName" label="Achternaam" sortable v-slot="props">{{
            props.row.lastName | capitalize
          }}</b-table-column>
          <!-- v-if="props.row.organizations != undefined" -->
          <b-table-column cell-class="pointer" field="organisation" label="Organisatie" sortable v-slot="props">{{
            props.row.organizations[0] | organisationFormated
          }}</b-table-column>

          <b-table-column
            cell-class="pointer"
            field="isEnabled"
            label="Actief"
            :custom-sort="sortBool"
            sortable
            centered
            v-slot="props"
          >
            <active-check-component :checked="props.row.isEnabled" />
          </b-table-column>

          <!-- TODO: change and add tooltip -->
          <b-table-column v-if="showAdminButton" field="isAdmin" label="Admin" sortable centered v-slot="props">
            <span>
              <div style="display: inline-block">
                <b-tooltip label="DataAdministrator">
                  <div class="row-icon-div" @click="changeAdminRole(props.row, false)" style="cursor: default">
                    <img
                      class="row-icon"
                      v-if="props.row.roles != null && props.row.roles.length > 0"
                      :src="props.row.roles.includes('DataAdministrator') | dataImg"
                    />
                    <img class="row-icon" v-else :src="false | dataImg" />
                  </div>
                </b-tooltip>

                <b-tooltip label="GlobalAdministrator">
                  <div class="row-icon-div" @click="changeAdminRole(props.row, true)" style="cursor: default">
                    <img
                      class="row-icon"
                      v-if="props.row.roles != null && props.row.roles.length > 0"
                      :src="props.row.roles.includes('GlobalAdministrator') | adminImg"
                      preserveAspectRatio="none"
                    />
                    <img class="row-icon" v-else :src="false | adminImg" />
                  </div>
                </b-tooltip>
              </div>
            </span>
          </b-table-column>
        </template>
      </b-table>
      <div style="font-size: 2px">
        Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from
        <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a>
      </div>
    </div>

    <div v-if="selectedUser != null" class="detailsItemContainer">
      <personal-details :user="selectedUser" claimType="Project"></personal-details>
      <!-- fix inactive user error -->
    </div>
  </div>
</template>

<script>
import admin from '@/services/adminService'
import TitleBlock from '@/components/General/TitleBlock'
import PersonalDetails from '@/components/Admin/PersonalDetails'
import ProjectService from '@/services/projectService'
import { mapGetters } from 'vuex'
import ActiveCheckComponent from './ActiveCheckComponent.vue'

export default {
  components: {
    TitleBlock,
    PersonalDetails,
    ActiveCheckComponent
  },

  filters: {
    organisationFormated: function (value) {
      if (!value) return ''
      else if (value.identifier == 1) {
        return 'Atlas Techrin International'
      }
      return ''
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    adminImg: function (value) {
      console.log(value)
      if (!value) return '../../static/administrator-false.svg'
      return '../../static/administrator-true.svg'
    },
    dataImg: function (value) {
      console.log(value)
      if (!value) return '../../static/data-false.svg'
      return '../../static/data-true.svg'
    }
  },
  data() {
    return {
      accounts: [],
      searchTerm: '',
      perPage: 15,
      isImageModalActive: false,
      checkedClass: 'fas fa-checked',
      timesClass: 'fas fa-times',
      counter: 0,
      defaultOrga: 'Atlas Techrin International',
      showAdminButton: false
    }
  },

  computed: {
    ...mapGetters(['selectedUser', 'projectList', 'adminClaim']),
    sortedOrganisationClaims: function () {
      if (!this.claimsForSelectedUser || this.claimsForSelectedUser.length == 0) return
      const sorted = this.claimsForSelectedUser
      const filteredOrganisationClaims = sorted.filter(c => c.scope == 'Organization')
      return filteredOrganisationClaims.sort((a, b) => a.identifier - b.identifier)
    },
    filteredAccounts: function () {
      if (this.searchTerm == '' || !this.searchTerm || !this.accounts) {
        return this.accounts
      }
      const st = this.searchTerm.toLowerCase()
      return this.accounts.filter(
        a =>
          a.firstName.toLowerCase().includes(st) ||
          a.lastName.toLowerCase().includes(st) ||
          a.email.toLowerCase().includes(st)
      )
    }
  },
  mounted() {
    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows
    this.initData()
  },

  beforeDestroy() {
    localStorage.setItem('pagedTableRows', this.perPage)
  },

  methods: {
    async changeAdminRole(user, isAdminRole) {
      try {
        if (isAdminRole) {
          if (user.roles.includes('GlobalAdministrator')) {
            user.roles = [...user.roles.filter(e => e !== 'GlobalAdministrator')]
            await admin.removeRoles(user, 'GlobalAdministrator')
            console.log(user.firstName + 'has been removed as Global Admin')
          } else {
            user.roles = ['GlobalAdministrator', ...user.roles]
            await admin.insertRoles(user, 'GlobalAdministrator')
            console.log(user.firstName + 'has been given the role Global Admin')
          }
        } else {
          if (user.roles.includes('DataAdministrator')) {
            user.roles = [...user.roles.filter(e => e !== 'DataAdministrator')]
            await admin.removeRoles(user, 'DataAdministrator')
            console.log(user.firstName + 'has been removed as Data Admin')
          } else {
            user.roles = [...user.roles, 'DataAdministrator']
            await admin.insertRoles(user, 'DataAdministrator')
            console.log(user.firstName + 'has been given the role Data Admin')
          }
        }

        const temp = this.searchTerm
        this.searchTerm = this.searchTerm + ' '
        this.$nextTick(() => {
          this.searchTerm = temp
        })
      } catch (error) {
        console.log(error)
      }
    },
    roleToImage(item, isAdminImage) {
      if (item == undefined || item.length == 0)
        return !isAdminImage ? '../../static/DataFalse.svg' : '../../static/administratorFalse.svg'

      if (isAdminImage) {
        return item.includes('GlobalAdministrator')
          ? '../../static/administratorTrue.svg'
          : '../../static/administratorFalse.svg'
      }
      return item.includes('DataAdministrator') ? '../../static/data-true.svg' : '../../static/data-false.svg'
    },
    async GetOrRefreshData() {
      //refresh bearerToken
      await this.$store.dispatch('getBearerToken')
      this.accounts = (await admin.getAccounts()).data.accounts
      this.accounts.forEach(async ac => {
        const accountRoles = await admin.getRolesForUser(ac)
        ac.roles = accountRoles.data.roles
      })
    },
    async initData() {
      await this.GetOrRefreshData()
      this.$store.dispatch('getProjectList')
    },
    sortBool(a, b, isAsc) {
      if (isAsc) {
        return b.isEnabled - a.isEnabled
      }
      return a.isEnabled - b.isEnabled
    },
    async rowClicked(row) {
      await this.getClaimsForUsers(row)
      this.$store.commit('setSelectedUser', row)
      this.isImageModalActive = true
    },
    async getClaimsForUsers(account) {
      const accountClaims = await this.claimCallServer(account)
      const claimsAndProjects = this.attachProjectProps(accountClaims)
      account.leftProjectList = claimsAndProjects[1]
      const projectClaim = claimsAndProjects[0].filter(c => c.scope == 'Project')
      account.myClaims = projectClaim
      const organisationClaim = claimsAndProjects[0].filter(c => c.scope == 'Organization')
      account.organisation = ''
      if ((organisationClaim != null) & (organisationClaim.length > 0)) {
        if (organisationClaim[0].identifier == 1) {
          account.organisation = this.defaultOrga
        }
      }
      // account.roles = accountRoles
    },
    async claimCallServer(account) {
      return await admin.getClaimForUser(account)
    },
    attachProjectProps(userclaims) {
      const leftProjectList = this.projectList.map(p => p)
      const claims = _.values(userclaims)[0].claims
      for (const claim of claims) {
        const projectData = this.projectList.find(p => p.projectId == claim.identifier)
        const index = leftProjectList.indexOf(projectData)
        Object.assign(claim, projectData)
        if (index > -1) {
          leftProjectList.splice(index, 1)
        }
      }
      return [claims, leftProjectList]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/main.scss';

td {
  cursor: pointer;
  span {
    justify-content: center;
    align-items: center;
  }
}
.checked {
  color: gray;
}
.unchecked {
  color: $black;
}
.table {
  .button {
    background-color: $white;
    color: $fsdyellow;
    border-color: black;
    border-width: 0.2px;
  }
}
.tableSettings {
  .field {
    .label {
      padding: 3px;
      display: inline-block;
    }
    .input {
      margin-left: 1px;
      width: 200px;
      background-color: $white;
    }
    .button {
      font-size: 0.75rem;
      background-color: white;
    }
    .control {
      margin-left: 5px;
      .select select {
        background-color: transparent;
      }
    }
  }
}
.padtop10 {
  padding-top: 10px;
}
.accountstitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.flexContainer {
  display: flex;
  justify-content: space-between;
  .tableItemContainer {
    flex: 1 100%;
    padding: 10px;
    margin: 0px 30px 0px 30px;
  }
  .detailsItemContainer {
    float: right;
    width: 500px;
  }
}
.router-view {
  padding: 0px;
}
.accounts-table {
  border: 1px solid #e0e0e0;
}
.row-icon-div {
  height: 28px;
  width: 40px;
  display: inline-block;
}
.row-icon {
  height: 100%;
  width: 100%;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Accounts.vue